import { closeDarkIcon } from "../../../../common/vector";

interface PassengerRemoveButtonProps {
  onClick: () => void;
}

export default function PassengerRemoveButton({ onClick }: PassengerRemoveButtonProps) {
  return (
    <div onClick={onClick} className="passenger-remove">
      <img src={closeDarkIcon?.default} alt="close-dark" />
    </div>
  );
}
